import { render, staticRenderFns } from "./MinM.vue?vue&type=template&id=9a5319b0&scoped=true&"
import script from "./MinM.vue?vue&type=script&lang=js&"
export * from "./MinM.vue?vue&type=script&lang=js&"
import style0 from "./MinM.vue?vue&type=style&index=0&id=9a5319b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5319b0",
  null
  
)

export default component.exports